export default {
    member_login: '/member/doLogin', //用户登录
	member_register: '/member/doRegister', //用户注册
    user_info: '/member/getUserInfo', //用户信息获取
    user_set_loginpw: '/member/setLoginPassword', //更新用户登录密码
    user_get_bank: '/member/getUserBankInfo', //获取用户的银行卡信息
    user_set_bank: '/member/setBank', //更新用户银行卡
    user_set_paypw: '/member/setPayPassword', //更新用户支付密码

    setIdentity:'/member/setIdentity', //保存身份证信息
    setPersonalInfo:'/member/setPersonalInfo', //保存个人信息

    getbanner: '/system/config',  //获取banner
    getloansetting: '/system/base', //获取贷款配置
    addloan: '/Loans/addLoans', //提交申请
    getloan: '/Loans/getLoans', //获取合同

    duupload: '/system/doupload', //上传图片
    setsign: '/member/setSign',  //设置签名

    user_get_withdraw_role: '/member/getUserWithdrawRole', //获取用户提现规则
    user_set_withdraw: '/member/setUserWirhdraw', //获取用户提现规则
user_get_withdraw_list: '/member/getUserWithdrawList', //获取用户提现记录
}
